import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { captureSelectedPlan } from "./utils/selected-plan";
import { CommonModule } from "@angular/common";
import { RouterOutlet } from "@angular/router";
import { splashLoaderServiceInjectionToken } from "./components/splash-loader/splash-loader-service-injection-token";
import { ISplashLoaderService } from "./components/splash-loader/i-splash-loader.service";
import {
  splashLoaderStateServiceInjectionToken
} from "./components/splash-loader/splash-loader-state-service-injection-token";
import { ISplashLoaderStateService } from "./components/splash-loader/i-splash-loader-state.service";
import { combineLatest, filter, map, Observable, Subscription } from "rxjs";
import { NavigationEnd, Router } from "@angular/router";
import { SplashLoaderComponent } from "./components/splash-loader/splash-loader.component";
import { GtmService } from "./services/gtm/gtm.service";
import { BlockingLoaderComponent, IThemeService, themeServiceInjectionToken } from "@zaeper/angular-dashboard-view-lib";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    SplashLoaderComponent,
    BlockingLoaderComponent
  ]
})
export class AppComponent implements OnInit, OnDestroy {
  public readonly title: string = "Zaeper | User Dashboard";
  public isVisible$: Observable<boolean>;
  public isBlockingLoader$: Observable<boolean>;
  public showSplashLoader$: Observable<boolean>;
  private readonly _subscriptions: Subscription = new Subscription();

  constructor(
    @Inject(splashLoaderStateServiceInjectionToken) private readonly _splashLoaderStateService: ISplashLoaderStateService,
    @Inject(splashLoaderServiceInjectionToken) private readonly _splashLoaderService: ISplashLoaderService,
    @Inject(themeServiceInjectionToken) private readonly _themeService: IThemeService,
    private readonly _router: Router,
    private readonly _gtmService: GtmService
  ) {
    this.isVisible$ = this._splashLoaderStateService.isVisible$;
    this.isBlockingLoader$ = this._splashLoaderStateService.isBlockingLoader$;
    this.showSplashLoader$ = combineLatest([this.isVisible$, this.isBlockingLoader$]).pipe(
      map(([isVisible, isBlockingLoader]) => isVisible || isBlockingLoader)
    );
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  ngOnInit(): void {
    // A plan handed over from the website's price calculator; the features page preselects it.
    captureSelectedPlan(window.location.search);
    this._gtmService.initialize();
    this._splashLoaderService.setIsVisible(true);

    this._subscriptions.add(this._router.events.pipe(filter(event => event instanceof NavigationEnd)).pipe(map((event) => <NavigationEnd>event)).subscribe((event: NavigationEnd) => {
      this._splashLoaderService.setIsVisible(false);
      this._splashLoaderService.setIsBlockingLoader(false);
      this._gtmService.trackPageView(event.urlAfterRedirects, this.title);
    }));
  }
}
